import React from 'react';

import {toRunsDataQueryConfig} from '../../containers/RunsDataLoader';
import type {PanelSpec} from '../../util/panelTypes';
import {type Query} from '../../util/queryTypes';
import {type MarimoConfig} from './common';

const PANEL_TYPE = 'Marimo';

const marimoTransformQuery = (query: Query) => {
  const transformed = toRunsDataQueryConfig(
    query,
    {selectionsAsFilters: true},
    {
      page: {size: 100},
      panelType: PANEL_TYPE,
    }
  );
  return transformed;
};

export const Spec: PanelSpec<typeof PANEL_TYPE, MarimoConfig> = {
  type: PANEL_TYPE,
  Component: React.lazy(() => import('./Component')),
  transformQuery: marimoTransformQuery,
  icon: 'heart',
  openSettingsDrawerOnCreate: true,
  settingsDrawerContent: 'marimo-settings',
};
